
import SwitchTo from './SwitchTo';

export default SwitchTo;